
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '@/admin/contexts/AdminAuthContext';

export default function AdminPage() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAdminAuth();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/admin/empresas', { replace: true });
      } else {
        navigate('/admin/login', { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, navigate]);

  return null;
}
